import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/common/icon-yen.svg'
import _imports_1 from '@/assets/img/common/icon-pin.svg'
import _imports_2 from '@/assets/img/common/icon-bag.svg'
import _imports_3 from '@/assets/img/common/icon-file.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-top-container -fill -blue" }
const _hoisted_3 = { class: "p-top-headingBlock" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "p-top-headingLv2" }, "保存した検索条件", -1)
const _hoisted_5 = { class: "p-top-search-parameters" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "p-top-card-search-parameters_box" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "年収マーク"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "勤務地マーク"
}, null, -1)
const _hoisted_10 = { class: "-clamp-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "職種マーク"
}, null, -1)
const _hoisted_12 = { class: "-clamp-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "条件マーク"
}, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "p-jobsearch-search_content"
}
const _hoisted_15 = { class: "p-jobsearch-search_saved-data" }
const _hoisted_16 = { class: "p-jobsearch-search_saved-data_dl" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", { class: "__salary" }, "年収", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("dt", { class: "__place" }, "勤務地", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dt", { class: "__job" }, "職種", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dt", { class: "__others" }, "その他", -1)
const _hoisted_21 = { class: "p-jobsearch-search_saved-data_buttons" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]

import { deleteSerchMypageService, getSerchMyPageListService, TrnSerchMyPageInfo } from '@/api/services/trnSerchMyPageService';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { DialogPrefData, JobSearchPublicDropdownData, DialogOccupData } from '@/types/mstMyPage';
import { onMounted, ref, watch } from 'vue';
import { RouterLink } from 'vue-router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'JobSearchSearchSaved',
  props: {
    reloadSavedSearches: { type: Boolean, default: false },
    isFromHome: { type: Boolean, default: false }
  },
  emits: ["refreshed", "applySavedSearch"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'refreshed'): void,
  (e: 'applySavedSearch', data: TrnSerchMyPageInfo): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { reloadSavedSearches: boolean, isFromHome: boolean }

const storeBase = MYPAGE_CONSTANTS.STORE_MST;
const HOME_VIEW_LIMIT = 3;

const store = useStore();
const serchList = ref<TrnSerchMyPageInfo[]>([]);





watch(() => props.reloadSavedSearches, (newVal) => {
  if (newVal) {
    loadSavedSearches();
    emit('refreshed');
  }
});

async function loadSavedSearches() {
  const searchs = await getSerchMyPageListService(props.isFromHome ? HOME_VIEW_LIMIT : 0);
  const mstAnualSlry = (await store.dispatch(storeBase.MST_ANUAL_SLRY)) as JobSearchPublicDropdownData[];
  const mstDialogPref = (await store.dispatch(storeBase.DIALOG_PREF)) as DialogPrefData;
  const mstDialogOccup = (await store.dispatch(storeBase.DIALOG_OCCUPATION)) as DialogOccupData;

  searchs.forEach(async (srch) => {
    // 年収
    let annualIncome = MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE;
    const incomeId = srch.serchContentObj?.jobsearch_anualslryvalue;
    if (incomeId) {
      const mstItem = mstAnualSlry.find(slry => slry.id == Number(incomeId));
      annualIncome = mstItem ? mstItem.text : '';
    }
    srch.annualIncome = annualIncome;

    // 勤務地
    let jobsearchAreaid: string[] = [];
    let jobsearchPrefid: string[] = [];
    let jobsearchCityid: string[] = [];
    if (srch.serchContentObj?.jobsearch_areaid) {
      jobsearchAreaid = srch.serchContentObj?.jobsearch_areaid?.split(',');
    }
    if (srch.serchContentObj?.jobsearch_prefid) {
      jobsearchPrefid = srch.serchContentObj?.jobsearch_prefid?.split(',');
    }
    if (srch.serchContentObj?.jobsearch_cityid) {
      jobsearchCityid = srch.serchContentObj?.jobsearch_cityid?.split(',');
    }
    const locations = [...jobsearchAreaid,
                      ...jobsearchPrefid,
                      ...jobsearchCityid
                    ];
    const localtionName: string[] = [];
    mstDialogPref.checkbox1.forEach(chk1 => {
      if (localtionName.length > 1) return;
      if (locations.includes(chk1.id.toString())) {
        localtionName.push(chk1.text);
      } else {
        chk1.checkbox2.forEach(chk2 => {
          if (localtionName.length > 1) return;
          if (locations.includes(chk2.id.toString())) {
            localtionName.push(`${chk1.text} ${chk2.text}`);
          } else {
            chk2.checkbox3.forEach(chk3 => {
              if (localtionName.length > 1) return;
              if (locations.includes(chk3.value.toString())) {
                localtionName.push(`${chk1.text} ${chk2.text} - ${chk3.text}`);
              }
            });
          }
        });
      }
    });
    if (localtionName.length == 0) {
      localtionName.push(MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE);
    } else if (localtionName.length > 1) {
      localtionName[1] = 'ほか';
    }
    srch.location = localtionName.join('、');

    // 職種
    let jobsearchOcupctg1id: string[] = [];
    let jobsearchOcupctg2id: string[] = [];
    let jobsearchOcupctg3id: string[] = [];

    if (srch.serchContentObj?.jobsearch_ocupctg1id) {
      jobsearchOcupctg1id = srch.serchContentObj?.jobsearch_ocupctg1id?.split(',');
    }
    if (srch.serchContentObj?.jobsearch_ocupctg2id) {
      jobsearchOcupctg2id = srch.serchContentObj?.jobsearch_ocupctg2id?.split(',');
    }
    if (srch.serchContentObj?.jobsearch_ocupctg3id) {
      jobsearchOcupctg3id = srch.serchContentObj?.jobsearch_ocupctg3id?.split(',');
    }
    const occups = [...jobsearchOcupctg1id,
                  ...jobsearchOcupctg2id,
                  ...jobsearchOcupctg3id,
                  ];
    const occupNames: string[] = [];
    mstDialogOccup.selectbox1.forEach(chk1 => {
      if (occupNames.length > 1) return;
      if (occups.includes(chk1.id.toString())) {
        occupNames.push(chk1.text);
      } else {
        chk1.selectbox2.forEach(chk2 => {
          if (occupNames.length > 1) return;
          if (occups.includes(chk2.id.toString())) {
            occupNames.push(chk2.text);
          } else {
            chk2.selectbox3.forEach(chk3 => {
              if (occupNames.length > 1) return;
              if (occups.includes(chk3.value.toString())) {
                occupNames.push(chk3.text);
              }
            });
          }
        });
      }
    });
    if (occupNames.length == 0) {
      occupNames.push(MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE);
    } else if (occupNames.length > 1) {
      occupNames[1] = 'ほか';
    }
    srch.occupation = occupNames.join('、');
  });

  serchList.value = [...searchs];
}

async function deleteSavedSearch(serchId: number) {
  if (confirm(MYPAGE_CONSTANTS.STRING.JOB_SEARCH_PUBLIC_REMOVE_CFM)) {
    try {
      await deleteSerchMypageService(serchId);
      await loadSavedSearches();
      store.dispatch('toasts/appendTimeToast', { label: MYPAGE_CONSTANTS.STRING.JOB_SEARCH_PUBLIC_REMOVE_DONE });
    } catch (err) {
      console.error(err);
    }
  }
}

function applySavedSearch(serch: TrnSerchMyPageInfo) {
  emit('applySavedSearch', serch);
}

onMounted(async () => {
  if (props.isFromHome) {
    loadSavedSearches();
  }
});

return (_ctx: any,_cache: any) => {
  return (__props.isFromHome)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (serchList.value.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_unref(RouterLink), {
                    class: "p-top-pageLink -blue",
                    to: "/jobsearch/public/?modal=modalSearch&tab=search-tab2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("すべて見る")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serchList.value, (serch) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: serch.srchId
                    }, [
                      _createElementVNode("a", {
                        class: "p-top-card-search-parameters",
                        onClick: _withModifiers(($event: any) => (applySavedSearch(serch)), ["prevent"]),
                        href: "#"
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("p", null, [
                            _hoisted_8,
                            _createElementVNode("span", null, _toDisplayString(serch.annualIncome), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_9,
                            _createElementVNode("span", null, _toDisplayString(serch.location), 1)
                          ]),
                          _createElementVNode("p", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("span", null, _toDisplayString(serch.occupation), 1)
                          ]),
                          _createElementVNode("p", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("span", null, _toDisplayString(serch.other), 1)
                          ])
                        ])
                      ], 8, _hoisted_6)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serchList.value, (serch) => {
            return (_openBlock(), _createElementBlock("div", {
              key: serch.srchId,
              class: "p-jobsearch-search_saved-data_card"
            }, [
              _createElementVNode("dl", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("dd", null, _toDisplayString(serch.annualIncome), 1),
                _hoisted_18,
                _createElementVNode("dd", null, _toDisplayString(serch.location), 1),
                _hoisted_19,
                _createElementVNode("dd", null, _toDisplayString(serch.occupation), 1),
                _hoisted_20,
                _createElementVNode("dd", null, _toDisplayString(serch.other), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  class: "p-jobsearch-btn __white",
                  type: "button",
                  onClick: ($event: any) => (deleteSavedSearch(serch.srchId!))
                }, "削除する", 8, _hoisted_22),
                _createElementVNode("button", {
                  class: "p-jobsearch-btn __blue",
                  type: "button",
                  onClick: ($event: any) => (applySavedSearch(serch))
                }, "この条件で検索する", 8, _hoisted_23)
              ])
            ]))
          }), 128))
        ])
      ]))
}
}

})